import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Dormís mal. Te despertás con calor y cansancio.', 'Tu cuerpo cambió sin avisar. Comés igual y te inflamás / subís fácil.', 'Niebla mental. Te cuesta concentrarte y te olvidás de cosas simples.', 'Energía baja. Todo te agota y a la tarde te caés.'];
  return <section className="bg-gradient-section py-12 md:py-16 px-4 md:px-8" data-id="element-213">
      <div className="max-w-4xl mx-auto space-y-16" data-id="element-214">
        {/* Story Block */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-card rounded-2xl p-8 md:p-12 border border-border relative overflow-hidden" data-id="element-215">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-cta" data-id="element-216" />

          <div className="space-y-6 pl-4 md:pl-6" data-id="element-217">
            <p className="italic text-lg md:text-xl text-foreground/80 font-body leading-relaxed" data-id="element-218">
              María Elena notó que su cintura cambió aunque comía igual que
              antes.
            </p>

            <p className="italic text-lg md:text-xl text-foreground/80 font-body leading-relaxed" data-id="element-219">
              Dormía mal. Se sentía inflamada.
            </p>

            <p className="text-xl md:text-2xl text-primary font-semibold font-display leading-relaxed" data-id="element-220">
              Pensó que era falta de disciplina… hasta que entendió que podía
              ser perimenopausia.
            </p>

            <p className="text-base md:text-lg text-foreground/90 font-body font-medium leading-relaxed" data-id="element-221">
              No era su culpa: su cuerpo estaba cambiando por dentro.
            </p>

            <p className="text-base md:text-lg text-foreground/90 font-body font-medium leading-relaxed" data-id="element-222">
              Hormonas, estrés y metabolismo ya no respondían igual.
            </p>

            <p className="text-base md:text-lg text-foreground/90 font-body font-medium leading-relaxed" data-id="element-223">
              Cuando entendió lo que pasaba, dejó de culparse y{' '}
              <span className="text-accent font-bold" data-id="element-224">
                empezó a hacer una estrategia distinta.
              </span>
            </p>
          </div>
        </motion.div>

        {/* Pain Points */}
        

        {/* Closing */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center pt-8" data-id="element-225">
          <p className="text-2xl md:text-3xl font-display font-bold leading-snug" data-id="element-226">
            Si te sentís así, no necesitás más fuerza de voluntad.{' '}
            <span className="text-gradient-gold" data-id="element-227">
              Necesitás una estrategia distinta.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}